import { isMobile } from '@/utils'

const commonRoutes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '统一身份认证-登录页',
      titleI18nKey: 'os_global_title0',
      layout: 'empty'
    }
  },
  {
    name: 'dontInstallWeComApp',
    path: '/DontInstallWeComApp',
    component: () => import('@/views/dontInstallWeComApp/index.vue'),
    meta: {
      title: '未安装应用',
      titleI18nKey: 'os_global_title0',
      layout: 'empty'
    }
  },
  {
    name: 'H5-Login',
    path: '/h5/login',
    component: () => import('@/views/login/index.h5.vue'),
    meta: {
      title: '统一身份认证-登录页',
      titleI18nKey: 'os_global_title0',
      layout: 'empty'
    }
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/error-page/404.vue'),
    meta: {
      title: '页面飞走了',
      titleI18nKey: 'os_global_title0',
      layout: 'empty'
    }
  },

  {
    name: '403',
    path: '/403',
    component: () => import('@/views/error-page/403.vue'),
    meta: {
      title: '没有权限',
      titleI18nKey: 'os_global_title0',
      layout: 'empty'
    }
  }
]

const pcRoutes = [
  {
    name: 'Setting',
    path: '/setting',
    component: () => import('@/views/setting/index.vue'),
    meta: {
      title: '账号设置',
      titleI18nKey: 'os_global_title4',
      layout: 'empty'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/setting/info/info.vue'),
        meta: {
          title: '账号设置',
          titleI18nKey: 'os_global_title4'
        }
      },
      {
        name: 'Account',
        path: 'account',
        component: () => import('@/views/setting/Account/Account.vue'),
        meta: {
          title: '账号设置',
          titleI18nKey: 'os_global_title4'
        }
      },
      {
        name: 'Info',
        path: 'info',
        component: () => import('@/views/setting/info/info.vue'),
        meta: {
          title: '账号设置',
          titleI18nKey: 'os_global_title4'
        }
      },
      {
        name: 'Cancellation',
        path: 'cancellation',
        component: () => import('@/views/setting/Cancellation/Cancellation.vue'),
        meta: {
          title: '账号设置',
          titleI18nKey: 'os_global_title4'
        }
      }
    ]
  }
]

const mobileRoutes = [
  {
    name: 'Setting',
    path: '/setting',
    component: () => import('@/views/setting/index.h5.vue'),
    meta: {
      title: '账号设置',
      layout: 'empty',
      titleI18nKey: 'os_global_title4'
    },
    query: {
      active: 'Account'
    }
  },
  {
    name: 'Cancellation',
    path: '/cancellation',
    component: () => import('@/views/setting/Cancellation/Cancellation.vue'),
    meta: {
      title: '账号设置',
      layout: 'empty',
      titleI18nKey: 'os_global_title4'
    }
  }
]

export const basicRoutes = commonRoutes.concat(isMobile() ? mobileRoutes : pcRoutes)
